import clsx from 'clsx'
import throttle from 'lodash/throttle'
import * as React from 'react'
import { useEffect, useRef, useState } from 'react'

import closeWhite from '../../../Assets/close_White.svg'
import HamburgerMenu from '../../../Assets/menu.png'
import Image from '../../atoms/Image'
import Alert from '../../molecules/Alert'
import DesktopMenu from './DesktopMenu/desktopmenu'
import MainMenu from './DesktopMenu/megamenuDesktop'
import MobileMenu from './MobileMenu/mobilemenu'
import './menu.css'

interface Props {
  content?: any
}

const Header = ({ content }: Props) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [isScrollingDown, setIsScrollingDown] = useState(false)
  const headerRef = useRef<HTMLDivElement>(null)

  const toggleMenu = () => {
    setIsMenuOpen((prevState) => !prevState)
    setIsScrollingDown(false)
  }

  useEffect(() => {
    document.body.style.overflow = isMenuOpen ? 'hidden' : 'unset'
  }, [isMenuOpen])

  useEffect(() => {
    let previousScrollY = 0
    const handleScroll = (): void => {
      if (typeof document !== 'undefined') {
        const isScrolledDown =
          (window.scrollY > previousScrollY && window.scrollY >= headerRef.current?.clientHeight) ||
          window.scrollY + window.innerHeight >= document.body.clientHeight
        setIsScrollingDown(isScrolledDown)
        previousScrollY = window.scrollY
      }
    }

    const setPreviousScrollY = () => {
      previousScrollY = window.scrollY
    }

    const handleScrollTop = () => {
      if (typeof document !== 'undefined' && window.scrollY === 0) setIsScrollingDown(false)
    }

    const throttleSetPreviousScrollY = throttle(setPreviousScrollY, 0)

    const throttlehandleScroll = throttle(handleScroll, 400, {
      trailing: false,
    })

    if (typeof document !== 'undefined') {
      document.addEventListener('scroll', throttlehandleScroll)
      document.addEventListener('scroll', handleScrollTop)
      document.addEventListener('scroll', throttleSetPreviousScrollY)

      return () => {
        document.removeEventListener('scroll', throttlehandleScroll)
        document.removeEventListener('scroll', handleScrollTop)
        document.removeEventListener('scroll', throttleSetPreviousScrollY)
      }
    }
  }, [])

  useEffect(() => {
    // add a timeout here so the classes is added after header is displayed
    // to allow animation to complete
    if (!isScrollingDown) {
      setTimeout(() => {
        headerRef.current.classList.add('overflow-visible')
      }, 300)
    }
  }, [isScrollingDown])

  return (
    <>
      {content?.fields?.globalAlert && (
        <Alert
          content={content?.fields?.globalAlert}
          background={content?.fields?.globalAlert?.fields?.backgroundColor}
        />
      )}
      <header className="sticky top-0 z-[900]">
        {/* header section start */}
        <div
          ref={headerRef}
          className={clsx(
            'h-full overflow-hidden transition-all duration-300 ease-in-out',
            isScrollingDown ? 'max-h-0' : 'max-h-[100vh]',
          )}
        >
          <div data-testid="header" className="layoutSpacing relative bg-purple-100">
            <div className="layout w-full py-24">
              <div className="flex items-center justify-between">
                <div className="logo w-[150px] lg:w-[170px]">
                  <a href="/" className="block h-64" aria-label="Go to Homepage">
                    <Image
                      imageUrl={content?.fields?.navigationSection?.fields?.logo?.fields?.file?.url}
                      altText={content?.fields?.navigationSection?.fields?.logo?.fields?.description || 'ESS Logo'}
                      height="100%"
                      width="auto"
                    />
                  </a>
                </div>
                {/* desktop view */}
                <div className="hidden w-full flex-row xl:flex">
                  <DesktopMenu content={content} />
                </div>
                {/* mobile View */}
                <div className="xl:hidden">
                  <button
                    aria-label="Open Mobile Menu"
                    onClick={toggleMenu}
                    className="navbutton text-neutral-10 focus:outline-none"
                  >
                    <img src={isMenuOpen ? closeWhite : HamburgerMenu} role="presentation" alt="hamburgerIcon" />
                  </button>
                </div>
              </div>
            </div>
            {isMenuOpen && <MobileMenu content={content} />}
          </div>
          {/* main navigation part start */}
          <MainMenu content={content} shouldMenuDisplay={!isScrollingDown} />
        </div>
      </header>
    </>
  )
}
export default Header
